import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'

const Phases = () => {
    const navigate = useNavigate();
  
  const [phases, setPhases] = useState([]);
  const [form, setForm] = useState({ phase: '' });
  const [isEdit, setIsEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getPhases = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-phases`, {
      withCredentials: true
    })
      .then(res => {
        setPhases(res.data.phases || []);
        setIsLoading(false);
      })
      .catch(err =>{globalErrorHandler(err, navigate);setIsLoading(false)});
  };

  useEffect(() => {
    getPhases();
  }, []);

  const openAddModal = () => {
    setForm({ phase: '' });
    setIsEdit(false);
    setShowModal(true);
    setSelectedId(null);
  };

  const openEditModal = (bt) => {
    setForm({ title: bt.title,description: bt.description });
    setIsEdit(true);
    setShowModal(true);
    setSelectedId(bt.id);
  };

  const validatePhaseForm = () => {

  if (!form.title?.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please enter a Phase name.'
    });
    return false;
  }
  return true;
};

  const savePhase = () => {
      if (!validatePhaseForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/create-phase`, form, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Phase added!', 'success');
          setShowModal(false);
          getPhases();
        }
      })
      .catch(err =>globalErrorHandler(err, navigate));
  };

  const updatePhase = () => {

          if (!validatePhaseForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-phase`, { ...form, id: selectedId }, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Phase updated!', 'success');
          setShowModal(false);
          getPhases();
        }
      })
      .catch(err =>globalErrorHandler(err, navigate));
  };

  const deletePhase = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the Phase.',
      icon: 'warning',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/delete-phase`, { id }, { withCredentials: true })
          .then(res => {
            if (res.data.status) {
              Swal.fire('Deleted!', res.data.message, 'success');
              getPhases();
            }
          })
         .catch(err =>globalErrorHandler(err, navigate));
      }
    });
  };

  return (
    <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Phases</h3>
        <Button variant="success" onClick={openAddModal}>Add New Phase</Button>
      </div>
      <table className="table table-bordered table-hover shadow-sm">
        <thead className="table-success">
          <tr>
            <th>Title</th>
            <th  style={{ width: "60%" }} >Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="2">Loading...</td></tr>
          ) : phases.length === 0 ? (
            <tr><td colSpan="2">No data found.</td></tr>
          ) : (
            phases.map(bt => (
              <tr key={bt.id}>
                <td>{bt.title}</td>
<td  style={{ maxWidth: "60%" }}>
  {bt.description?.length > 300 ? bt.description.slice(0, 300) + "..." : bt.description}
</td>               <td>
                  <Button variant="info" className="me-2" onClick={() => openEditModal(bt)}>Edit</Button>
                  <Button variant="danger" onClick={() => deletePhase(bt.id)}>Delete</Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Phase' : 'Add Phase'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </div>
           <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea className="form-control" 
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            >
            {form.description}
            </textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={isEdit ? updatePhase : savePhase}>
            {isEdit ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Phases;
